<ng-container *transloco="let t; prefix: 'maintenanceOverview.modals.reschedule'">
  <div class="modal-header">
    <h5 class="modal-title">{{ t('title') }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="modal-body">
    <p class="modal-description">{{ t('description') }}</p>
    <form [formGroup]="rescheduleForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <app-flatpickr-date-picker
          [label]="t('date')"
          [value]="dateValue"
          [minDate]="'today'"
          dateFormat="Y-m-d"
          [required]="true"
          (valueChange)="onDateChange($event)">
        </app-flatpickr-date-picker>
        @if (rescheduleForm.get('date')?.invalid && rescheduleForm.get('date')?.touched) {
          <div class="error-message">{{ t('dateRequired') }}</div>
        }
      </div>

      @if (maintenanceData.assignedTo) {
        <div class="form-group checkbox-group">
          <input
            type="checkbox"
            id="notifyTechnician"
            class="form-check-input"
            formControlName="notifyTechnician" />
          <label for="notifyTechnician" class="checkbox-label">{{ t('notifyTechnician') }}</label>
        </div>
      }

      <div class="modal-footer">
        <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>
        <button type="submit" class="reschedule-btn" [disabled]="isSubmitDisabled">
          @if (isLoading) {
            <span class="spinner-border"></span>
          }
          @if (!isLoading) {
            <span>{{ t('reschedule') }}</span>
          }
        </button>
      </div>
    </form>
  </div>
</ng-container>
